module.exports = __webpack_public_path__ + "img/第一生命香港有限公司(1).94663263.png";